module.exports = __webpack_public_path__ + "static/media/ski.0a07689e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Explore/images/ski.jpg
// module id = 1601
// module chunks = 0